import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    "doctor": null,
    "step": 0
}

const PatientAppointmentSlice = createSlice({
    name: 'patientAppointment',
    initialState,
    reducers: {
        updatePatientAppointment(state, { payload }) {
            state = { ...state, ...payload }
            return state
        },
        reset(state) {
            state = initialState
            return { ...state }
        },
        setPatientAppointment(state, { payload }) {
            state = payload
            return state
        }
    }

})


const PatientAppointmentReducer = PatientAppointmentSlice.reducer
export const PatientAppointmentActions = PatientAppointmentSlice.actions
export default PatientAppointmentReducer